export namespace Branding {
    export enum BrandingType {
        LoginScreenPromoImageMobile = "login_screen_promo_image_mobile",
        LoginScreenPromoImageWeb = "login_screen_promo_image_web",
        OfficialLogoSquare = "official_logo_square",
        OfficialLogoRectangular = "official_logo_rectangular",
        MobileAppLaunchScreenImage = "mobile_app_launch_screen_image",
        MobileAppIntroPageVideo = "mobile_app_intro_page_video"
    }

    export type Branding = {
        brandingId: number
        type: BrandingType
        url: string
        createdAt: string
        createdByProfileId: number
        deletedAt: string | null
        updatedAt: string
        updatedByProfileId: number | null
        campusId?: number | null
        campusIds?: number[]
        brandingIds?: number[]
        isPrimary: boolean
        subdomain?: string | null
    }

    export type BrandingCampusGroup = {
        campusIds: number[]
        isPrimary: boolean
        brandings: Branding[]
        brandingIds: number[]
    }

    export type BrandingDomainGroup = {
        subdomain: string | null
        campuses: BrandingCampusGroup[]
    }

    export type GetBrandingParams = {}

    export type BrandingItemData = {
        brandingId: number
        url: string
        campusId?: number | null
        campusIds?: number[]
        brandingIds?: number[]
        isPrimary: boolean
        subdomain?: string | null
    }

    export type BrandingData = {
        [key: string]: BrandingItemData
    }

    export type SetPrimaryBrandingsParams = {
        campusIds: number[]
        subdomain?: string | null
    }

    export type DeleteBrandingsParams = {
        brandingIds: number[]
        preserveCampusIds?: number[]
    }

    export type CreateSubdomainParams = {
        subdomain: string
    }

    export type DeleteSubdomainParams = {
        subdomain: string
    }
}
